import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeConfig } from 'flowbite-react';

import UploadPage from './pages/UploadPage';
import PreviewPage from './pages/PreviewPage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';

export default function App() {
  const [file, setFile] = useState(null);
  const [fields, setFields] = useState({});
  const [order, setOrder] = useState([]);
  const [mapping, setMapping] = useState({});
  const [uploadId, setUploadId] = useState(null);

  return (
    <>
      {/* Disable dark mode at runtime */}
      <ThemeConfig dark={false} />

      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <UploadPage
                  file={file}
                  setFile={setFile}
                  setFields={setFields}
                  setOrder={setOrder}
                  setMapping={setMapping}
                  setUploadId={setUploadId}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/preview/:uploadId"
            element={
              <ProtectedRoute>
                <PreviewPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </>
  );
}